module.exports = __webpack_public_path__ + "imgcvh/hero-7.4bcb8279.jpg";